<template>
  <ProgramKeyIndicatorContainer
    :class="{
      'shadow-none': fullScreen
    }"
  >
    <div class="flex flex-col flex-1 min-h-0">
      <div v-if="!fullScreen" class="text-sm flex items-center justify-between">
        <span>{{ data.label }}</span>
      </div>
      <div class="relative flex-1 min-h-0">
        <Pie
          :id="data.label"
          :data="chartData"
          :options="fullScreen ? fullScreenOptions : previewOptions"
        />
      </div>
      <div class="text-sm">
        {{ data.extra }}
      </div>
    </div>
  </ProgramKeyIndicatorContainer>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import {Pie} from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Filler,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    ArcElement, ChartOptions
} from 'chart.js';
import ProgramKeyIndicatorContainer from "@/program/components/program-statistics/ProgramKeyIndicatorContainer.vue";
import ProgramKeyIndicatorOptions from "@/program/services/ProgramKeyIndicatorOptions";
import {PieChartMarketStatistic} from "@/program/interfaces/Program";

ChartJS.register(Title, Tooltip, Legend, Filler, BarElement, CategoryScale, LinearScale, ArcElement);


const {fullScreen = false, data} = defineProps<{
    data: PieChartMarketStatistic;
    fullScreen?: boolean;
}>();

const chartData = computed(() => {
    return {
        labels: data.value.map(item => item.name),
        datasets: [{
            backgroundColor: [
                '#41b8a6',
                '#E46651',
                '#00D8FF',
                '#DD1B16',
                '#7741b8',
                '#e451d0',
                '#457031',
                '#1637dd',
                '#c9a779',
                '#3e80c2',
                '#621a1a',
                '#62ce3e'
            ],
            data: data.value.map(item => item.count)
        }]
    };
});

const chartOptions: ChartOptions<'pie'> = {
    ...ProgramKeyIndicatorOptions.chartDefaultOptions,
    elements: {
        arc: {
            borderWidth: 0
        }
    }
};

const previewOptions: ChartOptions<'pie'> = {
    ...chartOptions,
    ...ProgramKeyIndicatorOptions.chartPreviewOptions
} as ChartOptions<'pie'>;

const fullScreenOptions: ChartOptions<'pie'> = {
    ...chartOptions,
    ...ProgramKeyIndicatorOptions.chartFullScreenOptions
} as ChartOptions<'pie'>;
</script>
